export default "__VITE_ASSET__CuhMQg4B__"